import React, {useMemo} from "react";
import {t} from "i18next";
import css from "./Annotation.module.scss";

const Annotation = ({position, info, zoom, size = 1}) => {
  const {type, value, sightings} = info;

  const annotationStyle = useMemo(
    () => ({
      top: `${position.y - 35}px`,
      left: `${position.x + (15 + size * zoom * 30)}px`
    }),
    [position.x, position.y, size, zoom]
  );

  return (
    <div className={css.annotation} style={annotationStyle}>
      <div>
        <strong>{type}</strong>
      </div>
      <div>{value}</div>
      {sightings && (
        <div>
          {t("investigationDetail.graph.annotations.sightings", {
            count: sightings.length
          })}
        </div>
      )}
    </div>
  );
};

export default Annotation;
